'use client';

import {Icon} from '@components/@icons';
import {Link, useRouter} from '@components/@nav';
import {MeinText} from '@components/@typography/MeinText';
import {tid} from '@utils/tid';
import {useCrumbsStore} from '@utils/useCrumbsStore';
import classNames from 'classnames';
import {useTranslations} from 'next-intl';
import {FC} from 'react';
import styles from './MeinBackButton.module.css';

interface IProps {
    route?: string;
    label?: string;
    onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    className?: string;
    hideLabel?: boolean;
    fill?: string;
    testID?: string;
}

export const MeinBackButton: FC<IProps> = ({
    route,
    label,
    className,
    onClick,
    hideLabel,
    fill,
    testID,
}) => {
    const router = useRouter();
    const t = useTranslations('global');
    const crumbs = useCrumbsStore(state => state.crumbs);

    if (route) {
        const selectedCrumb = crumbs.find(c => c.startsWith(route)) || route;

        return (
            <Link
                href={selectedCrumb}
                className={classNames(styles.button, className, {
                    [styles.hideLabel]: hideLabel,
                })}
                onClick={onClick}
                {...tid(testID || '')}
            >
                <Icon
                    name="arrow-left"
                    className={styles.backArrowIcon}
                    color={fill ?? 'var(--color-icon-primary)'}
                />
                <MeinText tag="span" className={styles.label}>
                    {label ? label : t('back')}
                </MeinText>
            </Link>
        );
    }

    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
        onClick?.(e);
        if (e.defaultPrevented) {
            return;
        }
        router.back();
    };

    return (
        <button
            className={classNames(styles.button, className, {
                [styles.hideLabel]: hideLabel,
            })}
            onClick={handleClick}
        >
            <Icon
                name="arrow-left"
                className={styles.backArrowIcon}
                color={fill ?? 'var(--color-icon-primary)'}
            />

            <MeinText tag="span" className={styles.label}>
                {label ? label : t('back')}
            </MeinText>
        </button>
    );
};
